import React,{useState, useEffect} from "react";
import styled from "styled-components";
import theme from "../theme";
import {ReactComponent as IconoDown} from './../imagenes/down.svg';
import useObtenerConductores from "../hooks/useObtenerConductores";
import useObtenerViajes15minutos from './../hooks/useObtenerViajes15minutos';
import Swal from 'sweetalert2';


const ContenedorSelect = styled.div`
    border-bottom: 2px solid ${theme.grisClaro2};
    cursor: pointer;
    border-radius: 10px;
    position: relative;
    height: 2.5rem; /* 80px */
    width: 100%;
    padding: 0px 1.25rem; /* 20px */
    font-size: 1rem; /* 24px */
    text-align: center;
    display: flex;
    align-items: center;
    transition: .5s ease all;
    &:hover {
        background: ${theme.grisClaro};
    }
`;
const OpcionSeleccionada = styled.div`
    width: 100%;
    
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: space-between;
    svg {
        width: 1.25rem; /* 20px */
        height: auto;
        margin-left: 1.25rem; /* 20px */
    }
`;
const Opciones = styled.div`
    background: ${theme.grisClaro};
    position: absolute;
    top: 3.5rem; /* 90px */
    left: 0;
    width: 100%;
    border-radius: 0.625rem; /* 10px */
    max-height: 20rem; /* 300px */
    overflow-y: auto;
`;
const Opcion = styled.div`
    padding: 1.25rem; /* 20px */
    display: flex;

    svg {
        width: 28px;
        height: auto;
        margin-right: 1.25rem; /* 20px */
    }
    &:hover {
        background: ${theme.grisClaro2};
    }
`;


// Buscar Viajes en el mismo horario

const SelectMoviles15 =  ({movil, CambiarMovil, fechahoraviaje,id}) => {
const [fecha_hora15, cambiarfecha_hora15] = useState (new Date());
useEffect ( ()=>{    
    if(fechahoraviaje !== null)
    {cambiarfecha_hora15(fechahoraviaje);
}
},[movil,fechahoraviaje]);
const viajes15 = useObtenerViajes15minutos(fecha_hora15)
var viajes15filtro = viajes15.filter(item => item.estado !== 'Terminado')
viajes15filtro = viajes15filtro.filter(item => item.estado !== 'Cancelado')
viajes15filtro = viajes15filtro.filter(item => item.id !== id)
var movil1 = movil
const MovilViajes = viajes15filtro.filter(item => Number(item.numero_m) === Number(movil.numero))

//console.log(viajes15filtro)
//console.log(movil)
//console.log(MovilViajes.length)
if(MovilViajes.length>0){
    //console.log(id)
    CambiarMovil({numero:"Movil"})
    Swal.fire({
        title: 'Movil Ya asignado',
        text: 'El numero de Movil ya tiene un traslado en un rango de 15 minutos',
        icon: 'error',
        timer:4000
        })
} 

const moviles= useObtenerConductores();
moviles.sort((a, b) => (Number(a.numero) > Number(b.numero) ? 1 : Number(a.numero) < Number(b.numero) ? -1 : 0))
const movilesactivos = moviles.filter(item => item.estado === 'activo')

//console.log(viajes15)

const [mostrarSelect, cambiarMostrarSelect] = useState(false);

const handleClick = (e) => {
    const movilSeleccionado = movilesactivos.filter(item => item.id === e.currentTarget.dataset.valor)
    CambiarMovil(movilSeleccionado[0])
}

	return (
		<ContenedorSelect onClick={() => cambiarMostrarSelect(!mostrarSelect)}>
			<OpcionSeleccionada>{movil.numero} <IconoDown /></OpcionSeleccionada>

			{mostrarSelect &&
				<Opciones>
					{movilesactivos.map((movil) => {

                       // const movilFormateado = Object.keys(movil).map(function (key) {return {id : key, ...movil[key]};});
                       // console.log(movil)
						return <Opcion 
									key={movil.id}
									data-valor={movil.id}
									onClick={handleClick}
								>
									{movil.numero}
								</Opcion>
					})}
				</Opciones>
			}
		</ContenedorSelect>
	);
}
 
export default SelectMoviles15;